// User Login Actions

export const USER_LOGIN_REQUEST = 'USER_LOGIN_REQUEST';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_LOGOUT = 'USER_LOGOUT';

// USER Confrim Email Actions;

export const USER_CONFIRM_REQUEST = 'USER_CONFRIM_REQUEST';
export const USER_CONFIRM_SUCCESS = 'USER_CONFRIM_SUCCESS';
export const USER_CONFIRM_FAIL = 'USER_CONFIRM_FAIL';

// mechanic email check

export const MECHANIC_EMAIL_REQUEST = 'MECHANIC_EMAIL_REQUEST';
export const MECHANIC_EMAIL_SUCCESS = 'MECHANIC_EMAIL_SUCCESS';
export const MECAHNIC_EMAIL_FAIL = 'MECHANIC_EMAIL_FAIL';

// Forget Password

export const USER_FORGOT_REQUEST = 'USER_FORGOT_REQUEST';
export const USER_FORGOT_SUCCESS = 'USER_FORGOT_SUCCESS';
export const USER_FORGOT_FAIL = 'USER_FORGOT_FAIL';

// Reset Password

export const USER_RESET_PASSWORD_REQUEST = 'USER_RESET_PASSWORD_REQUEST';
export const USER_RESET_PASSWORD_SUCCESS = 'USER_RESET_PASSWORD_SUCCESS';
export const USER_RESET_PASSWORD_FAIL = 'USER_RESET_PASSWORD_FAIL';

// Clear Reset Password State

export const CLEAR_RESET_PASSWORD_STATE = 'CLEAR_RESET_PASSWORD_STATE';

// Mechanic Email

export const CLEAR_MECHANIC_EMAIL = 'CLEAR_MECHANIC_EMAIL';
